/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApiConfig} from '../config/api-config';
import {ResourceHelper} from '../../components/util/resource-helper';
import {AdnApiClientService} from '../common/controller/adn-api-client.service';

@Injectable({providedIn: 'root'})
export class TargetingSearchApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  searchKeywords(params: Record<string, any>): Observable<any> {
    return this.get('keywords', params);
  }

  searchCategories(params: Record<string, any>): Observable<any> {
    return this.get('categories', params);
  }

  searchKeyValues(params: Record<string, any>): Observable<any> {
    return this.get('keyvalues', params);
  }

  searchSimilarKeywords(params: Record<string, any>): Observable<any> {
    return this.get('targetingquery/searchtargeting', params);
  }

  createSemanticEmbedding(params: Record<string, any>): Observable<any> {
    return this.get('targetingquery/embedding', params);
  }

  searchKeywordProfiles(body: any, params: Record<string, any>): Observable<any> {
    return this.post('targetingquery/keywordprofiles2', body, params);
  }

  searchArticles(body: any, params: Record<string, any>): Observable<any> {
    return this.post('targetingquery/articles', body, params);
  }

  private get(path: string, params: Record<string, any>): Observable<any> {
    const normalized = {...params};
    if (Array.isArray(normalized.types)) {
      normalized.types = normalized.types.join(';');
    }
    if (!normalized.q && normalized.types && !normalized.blankOrderBy) {
      normalized.orderBy = 'NAME';
    }
    normalized.q = ResourceHelper.uiSrefUpdater(normalized.q);
    normalized.labels = ResourceHelper.uiSrefUpdater(normalized.labels);
    if (normalized.q && normalized.q.length < 3 && !normalized.q.endsWith('*')) {
      normalized.q += '*';
    }
    if (!normalized.objectState) {
      normalized.objectState = 'ACTIVE';
    }
    return this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(path),
      params: normalized
    });
  }

  private post(path: string, body: any, params: Record<string, any>): Observable<any> {
    return this.client.request({
      method: 'POST',
      url: this.apiConfig.getVersionedUri(path),
      params: params || {},
      body
    });
  }
}
